import React from 'react';
import { ReservationStatusTypes } from '../../api/reservation/reservation.types';

interface ReservationStatusLabelProps {
  status: ReservationStatusTypes;
  asText?: boolean;
}

export default class ReservationStatusLabel extends React.PureComponent<ReservationStatusLabelProps> {

  getColor = () => {
    if (this.props.status === ReservationStatusTypes.CONFIRMED) return 'success';
    if (this.props.status === ReservationStatusTypes.CANCELLED || this.props.status === ReservationStatusTypes.REQUEST_DENIED) return 'danger';
    if (this.props.status === ReservationStatusTypes.COMPLETED) return 'info';

    return 'secondary';
  };

  render() {
    return (
      <>
        { !this.props.asText ? (
          <span
            className={
                `badge badge-${this.getColor()}`
                    }
          >
            {this.props.status}
          </span>
        )
          : <div className={`text-${this.getColor()}`}>{this.props.status}</div>}
      </>
    );
  }
}
